import { ListRecordNavigation } from '@/components/common/ListRecordNavigation';
import { useInvoiceListNavigation } from './useInvoiceListNavigation';

/** Previous/next within the invoices table the slide-in was opened from. */
export function InvoiceListNavigation({ invoiceId }: { invoiceId: string }) {
  const navigation = useInvoiceListNavigation(invoiceId);
  if (!navigation) return null;
  return (
    <ListRecordNavigation
      subject="invoice"
      model={navigation.model}
      onOpen={navigation.open}
    />
  );
}
